import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDocumentTemplateIsEdit } from "./redux/actions";
import DocumentsTypesTable from "./documentTypesTable";
import './index.less'

const DocumentsTypesManager = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [canUpdate, setCanUpdate] = useState(false);
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (user?.permissions?.doc_types_manager?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Document Type Template Manager</span>
      <Row className="production-manager-parent-row">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]}>
            <Col>
              <div>
                <span className="heading-span" style={{ color: "#0d2843" }}>
                  Templates Register
                </span>
              </div>
            </Col>
            <Col>
              {canUpdate && (
                <Button
                  onClick={() => {
                    navigate(
                      "/settings/document-types-manager/create-template"
                    );
                    dispatch(setDocumentTemplateIsEdit(true));
                  }}
                  icon={<PlusOutlined />}
                  className="add-user-btn"
                  size="middle"
                  style={{ width: 125 }}
                >
                  TEMPLATE
                </Button>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <DocumentsTypesTable canUpdate={canUpdate} />
        </Col>
      </Row>
    </div>
  );
};

export default DocumentsTypesManager;
